/**
 * SpeedmasterCore.WebFont.js — Google Fonts injection
 *
 * Injects preconnect + Google Fonts stylesheet <link> tags into <head>.
 * Replaces the font loading previously handled by SC.ThreadsThemeExtension.LoadWebFont.
 *
 * Font family configurable via speedmaster.WebFontFamily
 * (default: "Barlow+Semi+Condensed").
 * Weights configurable via speedmaster.WebFontWeights
 * (default: "200;300;400;500;600;700").
 */
define('SpeedmasterCore.WebFont', [
    'SC.Configuration'
], function(Configuration) {
    'use strict';

    return {
        /**
         * Inject Google Fonts <link> tags into <head>.
         * Call once from mountToApp in any scope entry point.
         */
        inject: function inject() {
            var head = document.head || document.getElementsByTagName('head')[0];

            if (!head) { return; }

            // Avoid double-injection (SPA navigation re-runs mountToApp)
            if (head.querySelector('link[data-sm-webfont]')) { return; }

            var family = Configuration.get('speedmaster.WebFontFamily') || 'Barlow+Semi+Condensed';
            var weights = Configuration.get('speedmaster.WebFontWeights') || '200;300;400;500;600;700';

            // Preconnect for faster font loading
            var preconnect1 = document.createElement('link');
            preconnect1.rel = 'preconnect';
            preconnect1.href = 'https://fonts.googleapis.com';
            head.appendChild(preconnect1);

            var preconnect2 = document.createElement('link');
            preconnect2.rel = 'preconnect';
            preconnect2.href = 'https://fonts.gstatic.com';
            preconnect2.setAttribute('crossorigin', '');
            head.appendChild(preconnect2);

            // Google Fonts stylesheet
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family='
                + family + ':wght@' + weights + '&display=swap';
            link.setAttribute('data-sm-webfont', 'true');
            head.appendChild(link);
        }
    };
});
